// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { DefaultApi } from '@digitalasset/json-api-ts-client/index';
import React, { useContext } from 'react';

export const JsonApiContext = React.createContext<DefaultApi | undefined>(undefined);

export const useJsonApiClient: () => DefaultApi = () => {
  const client = useContext(JsonApiContext);
  if (!client) {
    throw new Error('Json API v2 client is not initialized');
  }
  return client;
};
